/**
 * @generated SignedSource<<f7797df6f43e9aa279f58757f517cf75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_sku">;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_sku";
};
export type PdpRespMarketplaceStickyHeader_sku$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_sku",
  "selections": [
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "catchNonFatalErrors",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "hasSkuId",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PriceDisplay_sku"
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "3447d0ebab7eff4fe27cf1a4bf508e8d";

export default node;
